(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const contactStatus = document.querySelector('#ContactForm .form-status');
  if (contactStatus) contactStatus.focus({preventScroll: true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucidius-catalog-hero"] && !Shopify.designMode) return;
  try {
    
const initializeMarketAutoplay = root => {
  root.querySelectorAll('.market-hero__slideshow[data-market-autoplay=true]').forEach(component => {
    if (component.dataset.autoplayReady) return;
    component.dataset.autoplayReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const play = component.play.bind(component);
    component.play = () => {
      if (motion.matches || component.matches(':hover') || component.contains(document.activeElement)) { component.pause(); return; }
      play();
    };
    component.slider.dataset.autoplay = 'true';
    component.setAutoPlay();
    const syncMotion = () => {
      if (motion.matches) { component.pause(); component.togglePlayButtonState(true); }
      component.sliderAutoplayButton.disabled = motion.matches;
    };
    motion.addEventListener('change', syncMotion);
    syncMotion();
  });
};
initializeMarketAutoplay(document);
document.addEventListener('shopify:section:load', event => initializeMarketAutoplay(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucidius-catalog-nav"] && !Shopify.designMode) return;
  try {
    
// Desktop: the catalog is either a bar of categories (always visible) or a
// Catalog button whose list stays open beside the hero on the home page. On
// mobile the panel is a full-screen drawer: page scroll is locked and focus
// stays inside it. The panel follows the <details> right before it.
// Past the header, the whole bar (categories and search) is fixed right under
// the sticky header and follows it: shown when the header is shown, moved out of
// view when it hides. Its slot keeps the bar's height so the page does not jump.
// The header's Catalog buttons show only while the bar is out of view. On
// mobile they open the drawer. On desktop they pin the same bar (or list) under
// the sticky header until Escape, a click outside or the bar coming back into view.
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const panelOf = menu => menu.nextElementSibling;
  const triggers = () => document.querySelectorAll('[data-catalog-open]');
  const headerBottom = () => Math.max(0, document.querySelector('.section-header')?.getBoundingClientRect().bottom || 0);
  const resetLevels = root => {
    root.querySelectorAll('.lucidius-catalog__item.is-open').forEach(item => {
      item.classList.remove('is-open');
      item.querySelector(':scope > .lucidius-catalog__drill')?.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('.lucidius-catalog__branch[open]').forEach(details => { details.open = false; });
  };
  const lock = () => document.body.classList.toggle('overflow-hidden-tablet', !desktop.matches && !!document.querySelector('.catalog-bar__menu[open]'));
  const expand = state => triggers().forEach(button => button.setAttribute('aria-expanded', state));
  // Content of a closed <details> can still report boxes, but Tab skips it.
  const focusable = root => [...root.querySelectorAll('a[href], button, summary')].filter(el => !el.closest('details:not([open]) > :not(summary)') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  let opener = null;
  const close = menu => {
    menu.open = false;
    const target = opener?.getClientRects().length ? opener : menu.querySelector(':scope > summary');
    opener = null;
    target.focus();
  };
  const pin = (bar, trigger, focus) => {
    const panel = bar.querySelector('.catalog-bar__panel');
    resetLevels(panel);
    // The categories move under the header; their place in the page keeps its size.
    if (bar.classList.contains('catalog-bar--desktop-bar')) {
      const box = panel.getBoundingClientRect();
      panel.style.minWidth = `${box.width}px`;
      panel.style.minHeight = `${box.height}px`;
    }
    bar.style.setProperty('--catalog-pinned-top', `${headerBottom()}px`);
    bar.classList.add('catalog-bar--pinned');
    const header = document.querySelector('sticky-header');
    if (header) header.preventHide = true;
    opener = trigger;
    expand(true);
    if (focus) focusable(panel)[0]?.focus();
  };
  const unpin = (bar, focus) => {
    const panel = bar.querySelector('.catalog-bar__panel');
    bar.classList.remove('catalog-bar--pinned');
    panel.style.minWidth = panel.style.minHeight = '';
    resetLevels(panel);
    const header = document.querySelector('sticky-header');
    if (header) header.preventHide = false;
    expand(false);
    if (focus && opener?.getClientRects().length) opener.focus();
    opener = null;
  };
  // Returns true while the bar is fixed and shown under the sticky header.
  const stick = () => {
    const holder = document.querySelector('.catalog-bar-frame');
    const head = document.querySelector('.section-header');
    if (!holder || !head) return false;
    const slot = holder.parentElement;
    const natural = slot.getBoundingClientRect().top;
    const stuck = head.classList.contains('shopify-section-header-sticky') && natural < head.offsetHeight;
    if (!stuck) {
      if (holder.classList.contains('catalog-bar-frame--stuck')) {
        holder.classList.remove('catalog-bar-frame--stuck', 'catalog-bar-frame--animate');
        slot.style.height = '';
      }
      return false;
    }
    const height = holder.offsetHeight;
    if (!holder.classList.contains('catalog-bar-frame--stuck')) {
      // Start from where the bar is now, then slide to its place under the header.
      slot.style.height = `${height}px`;
      holder.style.setProperty('--catalog-stuck-top', `${natural}px`);
      holder.classList.add('catalog-bar-frame--stuck');
      holder.getBoundingClientRect();
      holder.classList.add('catalog-bar-frame--animate');
    }
    const hidden = head.classList.contains('shopify-section-header-hidden');
    const top = hidden ? -height - 24 : head.offsetHeight;
    holder.style.setProperty('--catalog-stuck-top', `${top}px`);
    holder.style.setProperty('--catalog-stuck-bottom', `${Math.max(0, top + height)}px`);
    return !hidden;
  };
  let frame = 0;
  const sync = () => {
    frame = 0;
    const shown = stick();
    const bar = document.querySelector('.catalog-bar--ready');
    const top = headerBottom();
    const visible = shown || !bar || bar.getBoundingClientRect().bottom > top;
    triggers().forEach(button => { if (button.hidden !== visible) button.hidden = visible; });
    const pinned = document.querySelector('.catalog-bar--pinned');
    if (!pinned) return;
    if (visible || !desktop.matches) unpin(pinned, pinned.contains(document.activeElement));
    else pinned.style.setProperty('--catalog-pinned-top', `${top}px`);
  };
  const queue = () => { if (!frame) frame = requestAnimationFrame(sync); };
  const init = root => {
    root.querySelectorAll('.catalog-bar').forEach(bar => {
      const menu = bar.querySelector('.catalog-bar__menu');
      if (!menu) return;
      if (bar.classList.contains('catalog-bar--pinned')) unpin(bar, false);
      menu.open = bar.classList.contains('catalog-bar--home') && desktop.matches;
      resetLevels(bar);
      bar.classList.add('catalog-bar--ready');
      triggers().forEach(button => button.setAttribute('aria-controls', panelOf(menu).id));
    });
    lock();
    sync();
  };
  const layer = panel => panel.querySelector('.lucidius-catalog__item.is-open > .lucidius-catalog__sub') || panel.querySelector('.lucidius-catalog__branch[open] > .lucidius-catalog__panel') || panel.querySelector('.lucidius-catalog');
  init(document);
  desktop.addEventListener('change', () => init(document));
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('scroll', queue, {passive: true});
  window.addEventListener('resize', queue, {passive: true});
  // The header hides and shows by class; the bar follows in the same frame.
  const sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) new MutationObserver(sync).observe(sectionHeader, {attributes: true, attributeFilter: ['class']});
  // Focus moving into the bar while it is out of view brings the header back with it. While the
  // search has focus (a phone keyboard scrolls the page) the header and bar stay in place.
  document.addEventListener('focusin', event => {
    const header = document.querySelector('sticky-header');
    if (!header) return;
    if (event.target.closest?.('.catalog-bar-frame--stuck') && sectionHeader?.classList.contains('shopify-section-header-hidden')) header.reveal();
    if (event.target.closest?.('.catalog-bar__search')) header.preventHide = true;
    else if (!document.querySelector('.catalog-bar--pinned')) header.preventHide = false;
  });
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!menu.matches?.('.catalog-bar__menu')) return;
    lock();
    if (!desktop.matches) expand(menu.open);
    if (!menu.open) resetLevels(panelOf(menu));
    else if (!desktop.matches) panelOf(menu).querySelector('.lucidius-catalog__head--root .lucidius-catalog__close')?.focus();
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-catalog-open]');
    if (trigger) {
      const bar = document.querySelector('.catalog-bar--ready');
      const menu = bar?.querySelector('.catalog-bar__menu');
      if (!menu) return;
      if (!desktop.matches) {
        opener = trigger;
        menu.open = true;
      } else if (bar.classList.contains('catalog-bar--pinned')) unpin(bar, bar.contains(document.activeElement));
      else pin(bar, trigger, !event.detail);
      return;
    }
    if (event.target.closest('.catalog-bar__menu > summary')) opener = null;
    const button = event.target.closest('[data-catalog-close]');
    if (button) {
      close(button.closest('.catalog-bar').querySelector('.catalog-bar__menu'));
      return;
    }
    if (!desktop.matches) return;
    document.querySelectorAll('.catalog-bar--pinned').forEach(bar => {
      if (!bar.querySelector('.catalog-bar__panel').contains(event.target)) unpin(bar, false);
    });
    document.querySelectorAll('.catalog-bar__menu[open]').forEach(menu => {
      if (menu.contains(event.target) || panelOf(menu).contains(event.target)) return;
      if (menu.closest('.catalog-bar--home')) resetLevels(panelOf(menu));
      else menu.open = false;
    });
    document.querySelectorAll('.catalog-bar--desktop-bar .lucidius-catalog').forEach(nav => {
      if (!nav.contains(event.target)) resetLevels(nav);
    });
  });
  document.addEventListener('focusin', event => {
    const pinned = document.querySelector('.catalog-bar--pinned');
    if (pinned && !pinned.querySelector('.catalog-bar__panel').contains(event.target) && !event.target.closest?.('[data-catalog-open]')) unpin(pinned, false);
  });
  document.addEventListener('keydown', event => {
    if (event.defaultPrevented) return;
    const pinned = document.querySelector('.catalog-bar--pinned');
    if (pinned) {
      const panel = pinned.querySelector('.catalog-bar__panel');
      const inside = panel.contains(event.target);
      if (event.key === 'Escape') {
        event.preventDefault();
        unpin(pinned, inside || event.target === opener);
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusable(panel);
      if (!inside) {
        if (event.target === opener && !event.shiftKey && items.length) {
          event.preventDefault();
          items[0].focus();
        }
        return;
      }
      if (event.shiftKey && event.target === items[0]) {
        event.preventDefault();
        opener?.focus();
      } else if (!event.shiftKey && event.target === items[items.length - 1]) {
        // Leave the pinned bar for whatever follows the header's Catalog button.
        event.preventDefault();
        const order = opener ? focusable(opener.closest('header') || document.body) : [];
        const next = order[order.indexOf(opener) + 1] || opener;
        unpin(pinned, false);
        next?.focus();
      }
      return;
    }
    const bar = event.target.closest?.('.catalog-bar');
    const menu = bar?.querySelector('.catalog-bar__menu');
    if (!menu?.open) return;
    const panel = panelOf(menu);
    if (!menu.contains(event.target) && !panel.contains(event.target)) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close(menu);
      return;
    }
    if (event.key !== 'Tab' || desktop.matches) return;
    const items = focusable(layer(panel));
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (!items.includes(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucidius-footer"] && !Shopify.designMode) return;
  try {
    
const withdrawalFooterCleanups = new WeakMap();
const initializeWithdrawalFooter = root => {
  root.querySelectorAll('.atelier-footer').forEach(footer => {
    const link = footer.querySelector('[data-withdrawal-footer-link]');
    if (!link || footer.dataset.withdrawalObserved || !('IntersectionObserver' in window)) return;
    footer.dataset.withdrawalObserved = 'true';
    let visible = false;
    let host;
    let frame;
    let discoveryTimer;
    let shadowTimer;
    let discoveryObserver;
    let stopped = false;
    const stopDiscovery = () => {
      discoveryObserver?.disconnect();
      clearTimeout(discoveryTimer);
      clearInterval(shadowTimer);
    };
    const sync = () => {
      frame = null;
      if (stopped || !host?.shadowRoot) return;
      const shadow = host.shadowRoot;
      if (!shadow.querySelector('[data-lucidius-footer-visibility]')) {
        const style = document.createElement('style');
        style.setAttribute('data-lucidius-footer-visibility', '');
        style.textContent = ':host([data-lucidius-footer-visible]) .widerruf-trigger-button--floating{display:none!important}';
        shadow.appendChild(style);
      }
      host.toggleAttribute('data-lucidius-footer-visible', visible);
      footer.classList.add('atelier-footer--withdrawal-observed');
    };
    const schedule = () => {
      if (!stopped && frame == null) frame = requestAnimationFrame(sync);
    };
    const attachHost = candidate => {
      if (!candidate || host || stopped) return;
      host = candidate;
      // Discovery ends as soon as the app host is found.
      discoveryObserver?.disconnect();
      if (host.shadowRoot) {
        stopDiscovery();
        schedule();
      } else {
        // Shadow attachment has no light-DOM mutation; retry only this host.
        shadowTimer = setInterval(() => {
          if (!host.shadowRoot) return;
          stopDiscovery();
          schedule();
        }, 250);
      }
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      schedule();
    });
    observer.observe(link);
    discoveryObserver = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          const candidate = node.matches('.widerruf-popup-source--embed')
            ? node : node.querySelector('.widerruf-popup-source--embed');
          if (candidate) { attachHost(candidate); return; }
        }
      }
    });
    discoveryObserver.observe(document.body, {childList: true, subtree: true});
    discoveryTimer = setTimeout(stopDiscovery, 10000);
    attachHost(document.querySelector('.widerruf-popup-source--embed'));
    withdrawalFooterCleanups.set(footer, () => {
      stopped = true;
      stopDiscovery();
      observer.disconnect();
      cancelAnimationFrame(frame);
      host?.removeAttribute('data-lucidius-footer-visible');
      delete footer.dataset.withdrawalObserved;
      withdrawalFooterCleanups.delete(footer);
    });
  });
};
initializeWithdrawalFooter(document);
document.addEventListener('shopify:section:load', event => initializeWithdrawalFooter(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.atelier-footer').forEach(footer => withdrawalFooterCleanups.get(footer)?.());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucidius-subcollections"] && !Shopify.designMode) return;
  try {
    
// On a narrow screen the sibling row scrolls sideways: when the current category
// is out of view, scroll it in, with part of the previous one still showing.
document.querySelectorAll('.subcollections__chips').forEach(list => {
  const current = list.querySelector('[aria-current]');
  if (!current) return;
  const box = list.getBoundingClientRect();
  const item = current.getBoundingClientRect();
  if (item.left >= box.left && item.right <= box.right) return;
  list.scrollLeft += item.left - box.left - 48;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-activate-account"]) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-customer-password]');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(show));
    button.textContent = show ? button.dataset.hide : button.dataset.show;
  });
  const errorSummary = document.querySelector('.customer [data-customer-errors]');
  if (errorSummary) errorSummary.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-customer-password]');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(show));
    button.textContent = show ? button.dataset.hide : button.dataset.show;
  });
  const updateLoginHeading = () => {
    const title = document.querySelector('[data-customer-login-heading]');
    const source = document.getElementById(location.hash === '#recover' ? 'recover' : 'login');
    if (title && source) title.textContent = source.textContent.trim();
  };
  updateLoginHeading();
  window.addEventListener('hashchange', updateLoginHeading);
  const errorSummary = document.querySelector('.customer [data-customer-errors]');
  if (errorSummary) errorSummary.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  function initializeContentNavigation(root) {
    root.querySelectorAll('.lucidius-content-page').forEach((page, pageIndex) => {
      const nav = page.querySelector('.lucidius-content-page__toc nav');
      if (!nav || nav.children.length) return;
      const headings = [...page.querySelectorAll('.lucidius-content-page__body h2, .lucidius-content-page__body h3, .lucidius-content-page__body p')].filter(heading => {
        if (heading.matches('h2,h3')) return true;
        const strong = heading.querySelector('strong,b');
        const text = heading.textContent.trim();
        return strong && text.length > 0 && text.length <= 140 && strong.textContent.trim() === text;
      });
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `content-${pageIndex}-${index}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        nav.append(link);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeContentNavigation(document));
  else initializeContentNavigation(document);
  document.addEventListener('shopify:section:load', event => initializeContentNavigation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('.password-visibility');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(show));
    button.textContent = show ? button.dataset.passwordHide : button.dataset.passwordShow;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // The SKU line is re-rendered on variant change, so the copy button is handled by delegation.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-lucidius-copy-sku]');
    const sku = button?.closest('.product__sku')?.querySelector('.lucidius-sku-value')?.textContent.trim();
    if (!sku || !navigator.clipboard) return;
    navigator.clipboard.writeText(sku).then(() => {
      const done = button.parentElement.querySelector('.lucidius-copy-sku__done');
      if (!done) return;
      done.hidden = false;
      clearTimeout(done.lucidiusTimer);
      done.lucidiusTimer = setTimeout(() => { done.hidden = true; }, 2000);
    }, () => {});
  });

  document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(productInfo => {
    const reserveVolumeRow = () => {
      const slot = productInfo.querySelector('.lucidius-volume-slot');
      if (!slot) return;
      const variantId = productInfo.querySelector('input.product-variant-id')?.value;
      const variant = window.$Discounty?.products?.flatMap(product => product.variants || []).find(item => String(item.id) === variantId);
      const discount = variant?.discounts?.[0];
      const tiers = Number(discount?.operand_type) === 1 && [3, 4].includes(Number(discount?.discount_type)) && ['BOTH', 'ONE_TIME'].includes(discount?.purchaseType) ? (discount.tiers || []).filter(tier => Number(tier.criteria) > 1) : [];
      slot.hidden = tiers.length === 0;
      if (tiers.length) slot.style.setProperty('--lucidius-volume-height', `${5 + 3.5 * (tiers.length + 1)}rem`);
    };
    reserveVolumeRow();
    productInfo.addEventListener('pointerdown', event => {
      if (event.target.matches('.quantity__input')) event.target.setAttribute('data-pointer-focus', '');
    });
    productInfo.addEventListener('keydown', () => {
      productInfo.querySelectorAll('.quantity__input[data-pointer-focus]').forEach(input => input.removeAttribute('data-pointer-focus'));
    });
    const normalizeVolumeStyles = () => {
      reserveVolumeRow();
      const unitInfo = productInfo.querySelector('lucidius-product-volume');
      if (Number(unitInfo?.dataset.unitCount) > 0) {
        productInfo.querySelectorAll('.discounty-volume-discount-widget__discount').forEach(cell => {
          const copy = cell.textContent.replace(/\/(?:buc|piece|item)\b\.?/g, unitInfo.dataset.discountUnit);
          if (cell.textContent !== copy) cell.textContent = copy;
        });
      }
      productInfo.querySelectorAll('.discounty-volume-discount-widget [style]').forEach(element => {
        ['color', 'background', 'background-color', 'border', 'border-radius'].forEach(property => element.style.removeProperty(property));
      });
    };
    normalizeVolumeStyles();
    const observer = new MutationObserver(normalizeVolumeStyles);
    observer.observe(productInfo, { childList:true, subtree:true });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(productInfo)) observer.disconnect();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-customer-password]');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(show));
    button.textContent = show ? button.dataset.hide : button.dataset.show;
  });
  const errorSummary = document.querySelector('.customer [data-customer-errors]');
  if (errorSummary) errorSummary.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-customer-password]');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(show));
    button.textContent = show ? button.dataset.hide : button.dataset.show;
  });
  const errorSummary = document.querySelector('.customer [data-customer-errors]');
  if (errorSummary) errorSummary.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  function initializeSearchHeaderCount(root) {
    const header = root.querySelector('.template-search__count');
    const count = root.querySelector('#ProductCount');
    if (!header || !count || count.dataset.secondaryCountBound) return;
    count.dataset.secondaryCountBound = 'true';
    new MutationObserver(() => { header.textContent = count.textContent.trim(); }).observe(count, {childList: true, subtree: true, characterData: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeSearchHeaderCount(document));
  else initializeSearchHeaderCount(document);
  document.addEventListener('shopify:section:load', event => initializeSearchHeaderCount(event.target));

  } catch(e) { console.error(e); }
})();
})();
